module.exports = __webpack_public_path__ + "img/Arnold.eafcad1f.png";